import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react'; // Components

import { FieldContainer, Field, Label, CharacterCounter } from '../field';
import { Helper } from '../Helper';
import calculateNodeHeight from './calculateNodeHeight'; // Hooks

import { useFieldValidation } from '../../hooks/validation-field';
import { handleValidateFormCharacter } from '../../hooks/validate-form-characters'; // Styles

import { CustomSup, TextareaField } from './mixins';
export var Textarea = function Textarea(_ref) {
  var value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '...' : _ref$placeholder,
      name = _ref.name,
      id = _ref.id,
      maxLength = _ref.maxLength,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      disabled = _ref.disabled,
      rules = _ref.rules,
      errors = _ref.errors,
      fieldOptions = _ref.fieldOptions,
      noBottomMargin = _ref.noBottomMargin;

  var _useFieldValidation = useFieldValidation(rules, errors, name, disabled),
      fieldStates = _useFieldValidation.fieldStates,
      classes = _useFieldValidation.classes,
      setValue = _useFieldValidation.setValue,
      setActive = _useFieldValidation.setActive;

  var _ref2 = fieldOptions || {},
      _ref2$allowOnlyText = _ref2.allowOnlyText,
      allowOnlyText = _ref2$allowOnlyText === void 0 ? false : _ref2$allowOnlyText;

  var _useState = useState(value ? value.toString().length : 0),
      _useState2 = _slicedToArray(_useState, 2),
      numCharacters = _useState2[0],
      setNumCharacters = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1]; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var _useState5 = useState(value),
      _useState6 = _slicedToArray(_useState5, 2),
      filteredValue = _useState6[0],
      setFilteredValue = _useState6[1]; // Mantenemos actualizado el numero que mostramos en cantidad de caracteres


  useEffect(function () {
    setNumCharacters((filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.toString().length) || 0);
  }, [filteredValue]);

  var handleOnChange = function handleOnChange(event, callback) {
    var value = event.target.value;
    var currentFilteredValue = allowOnlyText ? handleValidateFormCharacter({
      fieldValue: value
    }) : value;
    setFilteredValue(currentFilteredValue);
    setValue(currentFilteredValue);
    event.target.value = currentFilteredValue;
    callback && callback(event);
  };

  var handleOnBlur = function handleOnBlur(event, callback) {
    setActive(false);
    callback && callback(event);
  };

  var handleOnFocus = function handleOnFocus(event, callback) {
    setActive(true);
    callback && callback(event);
  };

  var handleResize = function handleResize(event) {
    var height = calculateNodeHeight(event.target, event.target.value);
    setHeight(height);
  };

  return React.createElement(FieldContainer, null, fieldOptions && fieldOptions.label && React.createElement(Label, {
    htmlFor: id || "textarea-".concat(name)
  }, fieldOptions.label, rules && rules.required && React.createElement(CustomSup, null, "*")), React.createElement(Field, Object.assign({}, fieldOptions, {
    states: Object.assign({}, fieldStates),
    className: classes
  }), React.createElement(TextareaField, Object.assign({
    style: {
      height: "".concat(height, "px")
    },
    name: name,
    id: id || "textarea-".concat(name),
    placeholder: placeholder,
    disabled: disabled,
    maxLength: maxLength,
    value: filteredValue,
    autoCorrect: "off",
    autoCapitalize: "off",
    autoComplete: "off",
    spellcheck: "false",
    onChange: function onChange(event) {
      return handleOnChange(event, _onChange);
    },
    onInput: function onInput(event) {
      return handleResize(event);
    },
    onPaste: function onPaste(event) {
      return handleResize(event);
    },
    onCut: function onCut(event) {
      return handleResize(event);
    },
    onFocus: function onFocus(event) {
      return handleOnFocus(event, _onFocus);
    },
    onBlur: function onBlur(event) {
      return handleOnBlur(event, _onBlur);
    }
  }, fieldOptions, {
    ref: rules
  })), maxLength && React.createElement(CharacterCounter, {
    errors: errors && errors[name]
  }, numCharacters, " / ", maxLength)), React.createElement(Helper, {
    name: name,
    fieldOptions: fieldOptions,
    errors: errors,
    noBottomMargin: noBottomMargin
  }));
};